<template>
  <div class="chart-container" :style="'height: ' + height + 'px'">
    <template v-if="dataIsLoaded">
      <canvas :id="canvasId"></canvas>
    </template>
  </div>
</template>

<script>
import {Chart} from 'chart.js';
import utils from "../../services/utils";

export default {
  name: "ChartLine",
  props: {
    chartData: {
      type: Object,
      required: true
    },
    height: {
      type: Number,
      default: 400
    },
    dataIsLoaded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      canvasId: utils.generateClientId()
    }
  },
  mounted() {
    if(this.dataIsLoaded) {
      this.$nextTick(() => {
        this.buildChart();
      })
    }
  },
  watch: {
    dataIsLoaded(newValue, oldValue) {
      if(newValue) {
        this.$nextTick(() => {
          this.buildChart();
        })
      }
    }
  },
  methods: {
    buildChart() {
      new Chart(document.getElementById(this.canvasId), {
        type: 'line',
        data: this.chartData,
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            align: 'end',
            labels: {
              boxHeight: 8,
              boxWidth: 8,
              padding: 20
            }
          },
          hover: {
            onHover: function(e) {
              let point = this.getElementAtEvent(e);
              if (point.length) e.target.style.cursor = 'pointer';
              else e.target.style.cursor = 'default';
            }
          },
          scales: {
            xAxes: [{
              gridLines: {
                display: true
              }
            }],
            yAxes: [{
              ticks: {
                beginAtZero: true,
              }
            }]
          },
        }
      });
    }
  },
}
</script>

<style lang="scss" scoped>

.chart-container {
  position: relative;
  margin: auto;
  width: 100%;
}
</style>
